<template>
      <div>
         <div class="dashboard-box">
          <v-card
            class=""
            tile
          >
            <div class="lf-search-form dashboard">
              <div class="flex flex-row flex-wrap">
                <div class="w-full lg:w-1/2">
                  <v-text-field
                    label="Search"
                    prepend-inner-icon="mdi-magnify"
                    v-model="search_keyword"
                    outlined
                    dense
                    hide-details
                    style="margin-top: 5px;"
                  ></v-text-field>

                  <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-2 ml-3 mr-3" />
                </div>

                <div class="w-full lg:w-1/2 -ml-6">
                  <div class="lf-search-location-box">
                    <v-combobox
                        label="Location"
                        prepend-inner-icon="mdi-map-marker-outline"
                        v-model="autocompleteLocationModel"
                        :items="locationFoundItems"
                        :search-input.sync="locationSearchText"
                        item-text="value"
                        item-value="id"
                        hide-no-data
                        return-object
                        outlined
                        dense
                        hide-details
                        @change="selectPlace()"
                        style="height: 40px; border: 0px; margin-top: 5px; margin-bottom: 5px;"
                      >
                    </v-combobox>

                    <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-4 ml-3 -mr-3" />
                  </div>
                </div>

                <div class="lf-search-form-search-type">
                  <v-radio-group
                    class="mt-3"
                    row
                    v-model="search_type"
                    >
                        <v-radio
                        label="Local"
                        :value="'local'"
                        on-icon="mdi-circle"
                        off-icon="mdi-circle-outline"
                        :ripple="false"
                        ></v-radio>
                        <v-tooltip bottom color="#434C5E">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-radio
                                label="Multi-Snipe"
                                :value="'in_depth'"
                                on-icon="mdi-circle"
                                off-icon="mdi-circle-outline"
                                :ripple="false"

                              ></v-radio>
                            </span>
                          </template>
                          <span>
                            <strong>Multi-Snipe:</strong>
                            <br />
                            Multi-Snipe search will look up all the zip codes of the city you selected, and then does a search for every keyword in zip code combination.
                            <br /><br />
                            <strong>WARNING:</strong>
                            <br />
                            This can use a lot of Google API credits. If we find 10 zip codes -  we do 10 searches vs. 1. Thats 10 times the API requests.
                            <br />
                            Example: If a Local Search brings in 60 results thats 3 api queries to get the data, and then another 60 to pull the phone number for every listing. 
                            <br />
                            Thats 120 credits. Now if we used the Multi-Snipe feature - ad there were 10 zip codes - we would repeat the process 10 times. That means we'd use 10x the API requests.
                            <br /><br />
                            <strong>Cost breakdown:</strong>
                            <br />
                            - Get Keyword & Location: $0.032
                            <br />
                            - Main Search: $0.032
                            <br />
                            - Business Detail: $0.18 for 60 results
                          </span>
                        </v-tooltip>
                    </v-radio-group>
                </div>

                <div class="lf-search-form-submit-button" @click="addSearch()">
                  <i v-if="savingSearch" class="fa fa-spin fa-spinner"></i>
                  <i v-else class="mdi mdi-magnify"></i>
                </div>
              </div>
            </div>
          </v-card>
        </div>
        <div v-if="add_search_error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
            <div v-html="add_search_error"></div>
        </div>
        <div id="map" style="height: 500px; width: 100%;"></div>



        <div v-if="loading" class="text-center p-4">

                <v-progress-linear
                :value="percentageCompleted"
                color="green"
                height="18"
                rounded
                striped
                class="mt-3 mb-3 w-60 mx-auto"
              >
                <template v-slot:default>
                  <span class="text-white">{{ percentageCompleted }}%</span>
                </template>
              </v-progress-linear>

            <i class="fa fa-spinner fa-spin text-blue-500 text-lg"></i>
            <p class="text-gray-600 mt-2">Searching for live data...</p>
        </div>
      <div v-else>
        <div v-if="search" class="mt-5 p-4">
          <div v-if="showConversationDialog" @click.self="showConversationDialog = false;" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
            <div class="w-full sm:w-1/2 lg:w-1/2 bg-white rounded-lg mx-6">

                <div class="">
                    
                    <v-skeleton-loader v-if="!activeChat" class="ml-3" type="article, article, article"></v-skeleton-loader>

                    <InboxThread v-if="activeChat" :key="activeChatKey" :activeChat="activeChat" :search_results="true" :business="selected_business" :search="search"></InboxThread>

                </div>

            </div>
        </div>

      
        <div class="float-right mb-3">
           
            <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="downloadCsv();" style="margin-top: -7px;">DOWNLOAD CSV</div>
            <div class="border-1 border-warning bg-warning text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="openModal();" style="margin-top: -7px;">Push to CRM</div>
        </div>

        

      <h1 :class="(($vuetify.breakpoint.xs) ? 'text-sm text-bold' : 'text-lg font-semibold mb-3')">
          <span v-if="search">
                {{ search.search_results.length }} leads
          </span>
      </h1>

      <div v-if="search" style="color: rgba(25, 35, 58, 0.6); font-size: 14px; margin-top: -10px;">{{ search.keyword }} in {{ search.location }} ({{ ((search.search_type == 'local') ? "local" : "multi-snipe") }})</div>

      <hr class="border-b border-gray-100 mb-3">

        <div class="dashboard-box mb-6">
            <v-card
            class="pa-2"
            tile
            >
                <div class="pl-2 pr-2 pb-3 search-results-filter">
                    <v-form class="pt-3 mb-6">
                        <v-row>
                            <v-col
                                cols="12"
                                lg="3"
                                md="4"
                                sm="6"
                                class="pl-4">
                                    <v-text-field
                                        prepend-inner-icon="mdi-magnify"
                                        placeholder="Search..."
                                        dense
                                        outlined
                                        hide-details
                                        v-model="filters.search"
                                    ></v-text-field>
                            </v-col>

                            <v-col
                                cols="12"
                                lg="9"
                                md="4"
                                sm="6"
                                class="pl-4">

                                <v-row>
                                    <v-col
                                        cols="12"
                                        lg="3"
                                        md="4"
                                        sm="6"
                                        class="pl-4">
                                        <v-select
                                            v-model="filters.phone_number_type"
                                            :items="items_phone_number_type"
                                            label="Phone Number Type"
                                            outlined
                                            dense
                                            hide-details
                                            clearable
                                            multiple
                                        ></v-select>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        lg="3"
                                        md="4"
                                        sm="6"
                                        class="pl-4">
                                        <v-select
                                            v-model="filters.rating"
                                            :items="items_rating"
                                            label="Rating"
                                            outlined
                                            dense
                                            hide-details
                                            clearable
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        lg="3"
                                        md="4"
                                        sm="6"
                                        class="pl-4 pr-4">
                                        <v-select
                                            v-model="filters.contacted"
                                            :items="contacted_items"
                                            label="Contacted"
                                            outlined
                                            dense
                                            hide-details
                                            clearable
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        lg="3"
                                        md="4"
                                        sm="6"
                                        class="pl-4">
                                        <div class="justify-between items-start mb-3">
                                            <v-menu
                                            bottom
                                            left
                                            style="width: 300px;"
                                            :close-on-click="true"
                                            :close-on-content-click="false"
                                            >
                                            <template v-slot:activator="{ on, attrs }">
                                                <div
                                                v-bind="attrs"
                                                v-on="on"
                                                class="flex flex-row items-center px-4 py-1 rounded text-xs border-1 border-gray-500 text-gray-600 cursor-pointer bg-white"
                                                style="width: 100%;"
                                                >
                                                <span class="mr-2" style="width: calc(100% - 20px)">More Filters</span>
                                                <span class="text-xs" style="padding-top: 3px;">
                                                    <i class="mdi mdi-filter-settings-outline" style="font-size: 16px;"></i>
                                                </span>
                                                </div>
                                            </template>

                                                <v-list class="table-menu-actions">
                                                    <div class="p-3">
                                                        <strong class="text-sm">More Filters</strong>

                                                        <v-row class="mt-2">
                                                            <v-col
                                                                cols="12"
                                                                lg="6"
                                                                sm="12"
                                                                class="pl-4">
                                                                <v-text-field
                                                                    v-model="filters.reviews"
                                                                    prefix="Less than"
                                                                    suffix="reviews"
                                                                    placeholder="0"
                                                                    @blur="getSearch()"
                                                                    center
                                                                    outlined
                                                                    dense
                                                                    hide-details
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col
                                                                cols="12"
                                                                lg="6"
                                                                sm="12"
                                                                class="pl-4">
                                                                <v-select
                                                                    v-model="filters.quote"
                                                                    :items="items_yes_no"
                                                                    label="Quote"
                                                                    outlined
                                                                    dense
                                                                    hide-details
                                                                    clearable
                                                                ></v-select>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col
                                                                cols="12"
                                                                lg="6"
                                                                sm="12"
                                                                class="pl-4">
                                                                <v-select
                                                                    v-model="filters.chat"
                                                                    :items="items_yes_no"
                                                                    label="Chat"
                                                                    outlined
                                                                    dense
                                                                    hide-details
                                                                    clearable
                                                                ></v-select>
                                                            </v-col>

                                                            <v-col
                                                                cols="12"
                                                                lg="6"
                                                                sm="12"
                                                                class="pl-4">
                                                                <v-select
                                                                    v-model="filters.claimed"
                                                                    :items="items_yes_no"
                                                                    label="Claimed"
                                                                    outlined
                                                                    dense
                                                                    hide-details
                                                                    clearable
                                                                ></v-select>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4 pr-4">
                                                            <v-select
                                                                v-model="filters.posts"
                                                                :items="items_yes_no"
                                                                label="Posts"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>

                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4 pr-4">
                                                            <v-select
                                                                v-model="filters.website"
                                                                :items="items_yes_no"
                                                                label="Website"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>
                                                        </v-row>
                                                        <v-row>
                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4 pr-4">
                                                            <v-select
                                                                v-model="filters.google_pixel"
                                                                :items="items_yes_no"
                                                                label="Google Pixel"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>

                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4 pr-4">
                                                            <v-select
                                                                v-model="filters.facebook_pixel"
                                                                :items="items_yes_no"
                                                                label="FB Pixel"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>
                                                        </v-row>
                                                        <v-row>
                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4">
                                                            <v-select
                                                                v-model="filters.twitter_url"
                                                                :items="items_yes_no"
                                                                label="Twitter"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>

                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4">
                                                            <v-select
                                                                v-model="filters.youtube_url"
                                                                :items="items_yes_no"
                                                                label="Youtube"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>
                                                        </v-row>
                                                        <v-row>
                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4">
                                                            <v-select
                                                                v-model="filters.facebook_url"
                                                                :items="items_yes_no"
                                                                label="Facebook"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>

                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4">
                                                            <v-select
                                                                v-model="filters.linkedin_url"
                                                                :items="items_yes_no"
                                                                label="Linkedin"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>
                                                        </v-row>
                                                        <v-row>
                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4">
                                                            <v-select
                                                                v-model="filters.instagram_url"
                                                                :items="items_yes_no"
                                                                label="Instagram"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>

                                                        <v-col
                                                            cols="12"
                                                            lg="6"
                                                            sm="12"
                                                            class="pl-4">
                                                            <v-select
                                                                v-model="filters.pinterest_url"
                                                                :items="items_yes_no"
                                                                label="Pinterest"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>
                                                        </v-row>
                                                        <v-row>
                                                        <v-col
                                                            cols="12"
                                                            lg="12"
                                                            sm="12"
                                                            class="pl-4">
                                                            <v-select
                                                                v-model="filters.email"
                                                                :items="items_yes_no"
                                                                label="Email"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                            ></v-select>
                                                        </v-col>
                                                        </v-row>
                                                    </div>
                                                </v-list>
                                            </v-menu>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-form>
                    
                    <v-skeleton-loader v-if="!search" type="article, article, article"></v-skeleton-loader>
                    <table class="w-full rg-datatable mt-4">
                      <thead class="border-b border-gray-100 w-full">
                        <tr>
                          <th>
                            <input type="checkbox" class="w-4 h-4" @change="toggleAll" :checked="allSelected" />
                          </th>
                          <th>Business</th>
                          <th>Phone</th>
                          <th>Reviews</th>
                          <th>Email</th>
                          <th>Social Media</th>
                          <th>Category</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody class="w-full">
                        <tr v-for="item in dados" :key="item.id">
                          <!-- Checkbox -->
                          <td>
                            <input type="checkbox" class="w-4 h-4" v-model="selectedRows" :value="item.id">
                          </td>

                          <!-- Business Name -->
                          <td class="font-bold text-sm" style="width: 20%;">
                            {{ item.name }}
                          </td>

                          <!-- Phone -->
                          <td class="text-sm">
                            <a :href="'tel:' + item.phone" class="text-blue-500">{{ item.formatted_phone_number || 'N/A' }}</a>
                          </td>

                          <!-- Reviews -->
                          <td class="text-sm">
                            <span class="v-chip theme--light v-size--small orange lighten-5 orange--text text--lighten-1">
                              <span class="v-chip__content">
                                <i class="fa fa-star mr-1"></i>
                                {{ item.rating + " (" + item.user_ratings_total + " reviews)" }}
                              </span>
                            </span>
                          </td>

                          <!-- Email -->
                          <td class="text-sm">
                            <span v-if="item.email !== 'N/A'" style="font-size: 12px;">
                              
                              <a :href="'mailto:' + item.email" class="ml-2 text-blue-500">{{ item.email ? item.email.split(",")[0] : "N/A" }}</a>
                            </span>
                            <span v-else>N/A</span>
                          </td>

                          <!-- Social Media -->
                          <td>
                            <a v-if="item.facebook_url" :href="item.facebook_url" style="font-size: 18px;margin: 5px;" target="_blank">
                              <i class="mdi mdi-facebook text-blue-500"></i>
                            </a>
                            <a v-if="item.twitter_url" :href="item.twitter_url" style="font-size: 18px;margin: 5px;" target="_blank">
                              <i class="mdi mdi-twitter text-blue-400"></i>
                            </a>
                            <a v-if="item.linkedin_url" :href="item.linkedin_url" style="font-size: 18px;margin: 5px;" target="_blank">
                              <i class="mdi mdi-linkedin text-blue-700"></i>
                            </a>
                            <a v-if="item.instagram_url" :href="item.instagram_url" style="font-size: 18px;margin: 5px;" target="_blank">
                              <i class="mdi mdi-instagram text-pink-500"></i>
                            </a>
                            <a v-if="item.website" :href="item.website" style="font-size: 18px;margin: 5px;" target="_blank">
                              <i class="fa fa-globe text-gray-500"></i>
                            </a>
                          </td>

                          <!-- Category -->
                          <td class="text-sm">
                            <span class="v-chip theme--light v-size--small blue lighten-5 blue--text text--lighten-1">
                              <span class="v-chip__content">
                                {{ formatCategory(JSON.parse(item.types || '[]')[0]) }}
                              </span>
                            </span>
                          </td>

                          <!-- Status -->
                          <td>
                            <span v-html="getStatusHtml(item)"></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>



                </div>
            </v-card>
        </div>
        </div>
      </div>
        <!-- popup push to templage -->
        <template>
          <div v-if="showModal" @click.self="hideModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div class="bg-white w-full max-w-lg rounded-lg shadow-lg">
              
              <!-- Header -->
              <div class="px-6 py-4 border-b flex justify-between items-center">
                <h2 class="text-lg font-semibold">Select Tags</h2>
                <button @click="hideModal" class="text-gray-500 hover:text-gray-700">
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <!-- Content -->
              <div class="p-6">
                <!-- Show Loading -->
                <div v-if="isLoading" class="text-center text-gray-500 text-sm">
                  <i class="fa fa-spinner fa-spin"></i> Loading tags...
                </div>
                <div v-else>

                  <!-- Show Error Message -->
                  <div v-if="errorMessage" class="bg-red-100 text-red-700 p-3 mb-3 rounded">
                    {{ errorMessage }}
                  </div>

                  <!-- Show Tags List -->
                  <div v-else-if="tags.length">
                    <label v-for="tag in tags" :key="tag.id" class="flex items-center space-x-2 mb-2">
                      <input type="checkbox" v-model="selectedTags" :value="tag.name" />
                      <span class="text-sm">{{ tag.name }}</span>
                    </label>
                  </div>

                  <!-- No Tags Message -->
                  <div v-else class="text-gray-500 text-sm text-center">
                    No tags available.
                  </div>
                </div>
                  
              </div>
              <!-- Footer -->
              <div class="px-6 py-4 border-t flex justify-end space-x-2">
                <button @click="hideModal" class="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400">
                  Close
                </button>
                <button @click="pushSelectedTags" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                  Push
                </button>
              </div>
              
            </div>
          </div>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from 'axios'
import $ from 'jquery'
import ReviewsTable from '@/components/ReviewsTable.vue'
import moment from 'moment'
import { GetSuggestions } from '@/utils/PlaceUtils'

import InboxThread from '@/views/panel/InboxThread.vue'
import { TabulatorComponent } from "vue-tabulator";
export default {
  metaInfo () {
    return {
      title: "Finder | " + this.$appName
    }
  },
  components: {
    'AwesomeLocalTable': TabulatorComponent,
    InboxThread,
    ReviewsTable
  },
  components: {
    
  },

  data () {
   return {
    search_keyword: null,
    locationEntries: [],
    search_type: 'local',
    add_search_error: null,
    savingSearch: false,
    autocompleteLocationModel: null,
    locationSearchText: null,
    locationid:null,
    map: null,
    marker: null,
    storedToken:null,
    storedLocationId:null,
    search_location: null,
    search: null,
    search_id:null,
    interval:null,
    loading: false,
    items_rating: ['4.5 stars and up', '4.0 stars and up', '3.5 stars and up', '3.0 stars and up', '2.5 stars and up', '2 stars and up', '4.5 stars and down', '4.0 stars and down', '3.5 stars and down', '3.0 stars and down', '2.5 stars and down', '2 stars and down'],

        items_phone_number_type: ['voip', 'landline', 'mobile'],

        items_yes_no: ['Yes', 'No'],

        contacted_items: ['Yes', 'No', 'Responded'],

        filters: {
            search: "",
            phone_number_type: null,
            rating: null,
            reviews: null,
            quote: null,
            chat: null,
            claimed: null,
            posts: null,
            google_pixel: null,
            facebook_pixel: null,
            contacted: null,
            website: null,
            twitter_url: null, youtube_url: null, facebook_url: null, linkedin_url: null, instagram_url: null, pinterest_url: null,
            email: null
        },

        showConversationDialog: false,

        selected_business: null,

        activeChat: null,
        activeChatKey: 0,

        dados: [],
        

        screenshot_options: ["No screenshot", "Their mobile Google Business screenshot", "Their desktop Google Business screenshot"],
        
        selected_searches: [],
        show_send_bulk: false,
        bulkSMSTemplate: null,
        bulkSMSScreenshot: "No screenshot",
        bulkSMSFromNumber: null,
        sendingBulk: false,
        selectedRows: [],
        showModal: false,
        tags: [],
        selectedTags: [],
        errorMessage: null,
        isLoading: false, 
        isPushing: false,
        percentageCompleted: 0, 

   }
  },
  computed: {
    ...mapGetters("auth", ["getGhlAccessToken", "getGhlLocationId"]),
      locationFoundItems () {
        return this.locationEntries
      },
      allSelected() {
        return this.selectedRows.length === this.dados.length && this.dados.length > 0;
      },
  },
  methods:{
    toggleAll(event) {
        if (event.target.checked) {
          this.selectedRows = this.dados.map(item => item.id); // Select all
        } else {
          this.selectedRows = []; // Deselect all
        }
      },
      downloadCsv() {
        let csv = 'Business, Address, Phone Number, Carrier, Number Type, Email, Website, Rating, Reviews, Maps URL, Category, Quote, Chat, Claimed, Posts, Facebook Pixel, Google Pixel, Twitter URL, Youtube URL, Facebook URL, LinkedIn URL, Instagram URL, Pinterest URL\n';
        
        // Sirf selected rows filter karna
        let selectedData = this.search.search_results.filter(row => this.selectedRows.includes(row.id));

        selectedData.forEach((row) => {
            let categories = row.types;
            categories = JSON.parse(categories);
            let category = categories[0];

            category = category.replace(/\_/g, " ");
            category = category.toLowerCase().replace(/\b[a-z]/g, letter => letter.toUpperCase());

            let csv_data = [
                '"' + row.name + '"',
                '"' + row.formatted_address + '"',
                row.formatted_phone_number,
                '"' + row.phone_number_carrier_name + '"',
                row.phone_number_type,
                '"' + ((row.email) ? row.email.split(",")[0] : "") + '"',
                '"' + ((row.website) ? row.website.split("?")[0] : "") + '"',
                row.rating,
                row.user_ratings_total,
                '"' + row.url + '"',
                category,
                ((row.on_mobile_using_quote == 1) ? "Yes" : "No"),
                ((row.on_mobile_using_chat == 1) ? "Yes" : "No"),
                ((row.google_claimed_business == 1) ? "Yes" : "No"),
                ((row.google_posts == 1) ? "Yes" : "No"),
                ((row.facebook_pixel == 1) ? "Yes" : "No"),
                ((row.google_pixel == 1) ? "Yes" : "No"),
                '"' + row.twitter_url + '"',
                '"' + row.youtube_url + '"',
                '"' + row.facebook_url + '"',
                '"' + row.linkedin_url + '"',
                '"' + row.instagram_url + '"',
                '"' + row.pinterest_url + '"',
            ]

            csv += csv_data.join(',');
            csv += "\n";
        });

        if (selectedData.length === 0) {
            alert("Please select at least one row to export.");
            return;
        }

        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = this.search.keyword + ' - ' + this.search.location + ".csv";
        anchor.click();
    },

    formatCategory(category) {
      if (!category) return "-";
      return category
        .replace(/[_-]/g, " ") // _ or - ko space se replace karega
        .toLowerCase() // Sabko lowercase me convert karega
        .replace(/\b[a-z]/g, letter => letter.toUpperCase()); // First letter capitalize karega
    },
    getStatusHtml(item) {
      if (item.responded) {
        return `<span class="v-chip theme--light v-size--small green lighten-5 green--text text--lighten-1">
                  <span class="v-chip__content" style="font-size: 11px !important; font-weight: bold;">Responded</span>
                </span>`;
      }
  
      if (item.contacted) {
        return `<span class="v-chip theme--light v-size--small blue lighten-5 blue--text text--lighten-1">
                  <span class="v-chip__content" style="font-size: 11px !important; font-weight: bold;">Contacted</span>
                </span>`;
      }
  
      return `<span class="v-chip theme--light v-size--small orange lighten-5 orange--text text--lighten-1">
                <span class="v-chip__content" style="font-size: 11px !important; font-weight: bold;">Not contacted</span>
              </span>`;
    },
    addSearch: async function() {
      this.add_search_error = null

      if (!this.search_keyword) {
        this.add_search_error = "Please enter keyword.";
        return;
      }

      if (!this.search_location) {
        this.add_search_error = "Please enter location.";
        return;
      }

      this.savingSearch = true;

      let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/searches/add-search', {
        search_keyword: this.search_keyword,
        search_location: this.search_location,
        search_type: this.search_type,
        uuid:this.uuid
      } , {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        },
      })

      if (response.data && response.data.search) {
            this.search_id = response.data.search;  // Store search ID
            this.startSearchPolling(); // Start polling
          }

      this.savingSearch = false
      this.search_keyword = null
      this.search_location = null
      this.autocompleteLocationModel = null
    },
    selectPlace() {
      let that = this
      $.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + this.autocompleteLocationModel.id + "&fields=name,rating,formatted_phone_number&key=AIzaSyAtBA0jGEnrTzfQlETQOECnG5FdXFBvycU", function(response) {
        that.company_name = that.autocompleteLocationModel.value.split(",")[0];
        let address = that.getAddressObject(response.results[0].address_components);
        let search_location = {};
        search_location.street_number = address.street_number;
        search_location.address = address.address;
        search_location.city = address.city;
        search_location.state = address.state;
        search_location.zip = address.zip;
        search_location.country = address.country;

        search_location.lat = response.results[0].geometry.location.lat;
        search_location.lng = response.results[0].geometry.location.lng;
        search_location.place_id = response.results[0].place_id;

        that.search_location = search_location;
      });
      $.get(`https://maps.googleapis.com/maps/api/geocode/json?place_id=${this.autocompleteLocationModel.id}&key=AIzaSyAtBA0jGEnrTzfQlETQOECnG5FdXFBvycU`, function(response) {
        if (response.results.length > 0) {
          let location = response.results[0].geometry.location;
          
          that.map.setCenter(location);
          that.marker.setPosition(location);
        }
      });
    },


    // Google Maps Initialization
    initMap() {
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: 40.730610, lng: -73.935242 }, 
        zoom: 12
      });

      this.marker = new google.maps.Marker({
        position: { lat: 40.730610, lng: -73.935242 }, 
        map: this.map
      });
    },

    redirectToGHL() {
      const clientId = "67a9d7c7b41eeda682fd1cac-m6yxfyoy";
      // const redirectUri = encodeURIComponent("http://127.0.0.1:8001/auth/callback");
      const redirectUri = encodeURIComponent("https://api.leads.ravu.me/auth/callback");
      const scope = encodeURIComponent("locations.readonly locations/tags.readonly contacts.write");

      const ghlAuthUrl = `https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&loginWindowOpenMode=self&state=${this.uuid}_${this.locationid}`;

      window.location.href = ghlAuthUrl;
    },
    getAddressObject(address_components) {

        var ShouldBeComponent = {
          street_number: ["street_number"],
          zip: ["postal_code"],
          address: ["street_address", "route"],
          state: [
            "administrative_area_level_1",
            "administrative_area_level_2",
            "administrative_area_level_3",
            "administrative_area_level_4",
            "administrative_area_level_5"
          ],
          city: [
            "locality",
            "colloquial_area",
            "political",
            "sublocality",
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality_level_3",
            "sublocality_level_4"
          ],
          country: ["country"]
        };

        var address = {
          street_number: "",
          zip: "",
          address: "",
          state: "",
          city: "",
          country: ""
        };
        address_components.forEach(component => {
          for (var shouldBe in ShouldBeComponent) {
            if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
              if (shouldBe === "country") {
                address[shouldBe] = component.short_name;
              } else {
                address[shouldBe] = component.long_name;
              }
            }
          }
        });
        return address;
    },

    async getSearch(ignoreLoading = false) {
          if (!ignoreLoading) this.search = null;
          this.loading = true;
          let response = await axios.post(
              process.env.VUE_APP_API_ENDPOINT + '/searches/get-search?id=' + this.search_id,
              // process.env.VUE_APP_API_ENDPOINT + '/searches/get-search?id=26064',
              {
                  filters: this.filters,
                  uuid: this.uuid 
              }, 
              {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  },
              }
          );

          this.search = response.data.search;

          this.percentageCompleted = parseFloat(response.data.search.percentage_completed);

          if (this.search.status === "completed") {
              this.loading = false;  
              this.dados = response.data.search.search_results;


                clearInterval(this.interval);
                this.interval = null;
        }

    },

          
    startSearchPolling() {
      if (this.interval) clearInterval(this.interval);

      this.getSearch(); 

      this.interval = setInterval(() => {
        this.getSearch();
      }, 3000); 
    },

    async fetchTags() {
      this.isLoading = true;
      this.errorMessage = null;
      try {
        const response = await fetch(process.env.VUE_APP_API_ENDPOINT + "/fetch-tags", {
          method: "POST",
          headers: { "Accept": "application/json", "Content-Type": "application/json" },
          body: JSON.stringify({
            storedToken: this.getGhlAccessToken,
            storedLocationId: this.getGhlLocationId
          })
        });

        const data = await response.json();

        if (data.statusCode === 403) {
          this.errorMessage = "The token does not have access to this location.";
        } else {
          this.tags = data.tags || [];
        }
      } catch (error) {
        this.errorMessage = "Error fetching tags. Please try again.";
      }
      this.isLoading = false;
    },

      // Show Popup & Fetch Tags
      openModal() {
        this.showModal = true;
        this.fetchTags();
      },

      // Hide Popup
      hideModal() {
        this.showModal = false;
        this.selectedTags = [];
      },

      // Log Selected Tags
     async pushSelectedTags() {
        if (!this.selectedRows.length) {
          this.errorMessage = "Please select at least one contact.";
          return;
        }
  
        this.isPushing = true;
        this.errorMessage = null;
        this.successMessage = null;
  
        try {
          const response = await fetch(process.env.VUE_APP_API_ENDPOINT + "/push-to-crm", {
            method: "POST",
            headers: { "Accept": "application/json", "Content-Type": "application/json" },
            body: JSON.stringify({
              storedToken: this.getGhlAccessToken,
              storedLocationId: this.getGhlLocationId,
              selectedTags: this.selectedTags,
              selectedRows: this.selectedRows
            })
          });
  
          const data = await response.json();
  
          if (data.success) {
            this.successMessage = "Contacts successfully pushed to CRM!";
            this.hideModal();
          } else {
            this.errorMessage = data.message || "Error pushing contacts.";
          }
        } catch (error) {
          this.errorMessage = "Network error. Please try again.";
        }
  
        this.isPushing = false;
        this.hideModal();
      },

    async processSendBulk() {
        this.sendingBulk = true;

        let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/inbox/send-bulk', {
            selected_searches: this.selected_searches,
            bulkSMSScreenshot: this.bulkSMSScreenshot,
            bulkSMSTemplate: this.bulkSMSTemplate,
            bulkSMSFromNumber: this.bulkSMSFromNumber
        }, {
            headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            },
        });

        this.$swal({
			title: "Done!",
			text: "Messages are scheduled to be sent in the next few minutes.",
			showCancelButton: false,
		});

        this.sendingBulk = false;
        this.show_send_bulk = false;
        this.selected_searches = false;
        this.bulkSMSScreenshot = "No screenshot";

        $('.tabulator-tableHolder input[type="checkbox"]').prop('checked', false);
    },


  },
  mounted() {
    this.locationid = this.$route.params.locationid; 
    this.initMap();    

    this.uuid = this.$route.params.uuid;

    this.storedToken = this.getGhlAccessToken;
    this.storedLocationId = this.getGhlLocationId;

    
      // Check if token is in URL
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    

    if (token) {
      console.log("Token found in URL:", token);
      this.$store.dispatch("auth/saveGhlAuth", { token, locationId: this.locationid });
      
      // Remove token from URL (Clean UX)
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    } else if (!this.storedToken || this.storedLocationId !== this.locationid) {
      console.log("No token found OR locationId changed, redirecting to GHL Auth...");
      this.redirectToGHL();
    }


  },
  beforeDestroy() {
      if (this.interval) clearInterval(this.interval); 
  },
  watch: {
    locationSearchText (newVal) {
      var that = this;

      // If less than 3 chars typed, do not search
      if (!newVal || newVal.length <= 3) return

      // Call the method from the previous section here
      GetSuggestions(newVal)
        .then(function (res) {
          that.locationEntries = res;
        })
        .catch(function () {
          that.business = false;
          that.step = 1;
        })
    },
    'filters.search'(newVal) {
      this.getSearch(true);
    },
    'filters.phone_number_type'(newVal) {
      this.getSearch();
    },
    'filters.rating'(newVal) {
      this.getSearch();
    },
    // 'filters.reviews'(newVal) {
    //   this.getSearch();
    // },
    'filters.quote'(newVal) {
      this.getSearch();
    },
    'filters.chat'(newVal) {
      this.getSearch();
    },
    'filters.claimed'(newVal) {
      this.getSearch();
    },
    'filters.posts'(newVal) {
      this.getSearch();
    },
    'filters.google_pixel'(newVal) {
      this.getSearch();
    },
    'filters.facebook_pixel'(newVal) {
      this.getSearch();
    },
    'filters.contacted'(newVal) {
      this.getSearch();
    },
    'filters.website'(newVal) {
      this.getSearch();
    },
    'filters.twitter_url'(newVal) {
      this.getSearch();
    },
    'filters.youtube_url'(newVal) {
      this.getSearch();
    },
    'filters.facebook_url'(newVal) {
      this.getSearch();
    },
    'filters.linkedin_url'(newVal) {
      this.getSearch();
    },
    'filters.instagram_url'(newVal) {
      this.getSearch();
    },
    'filters.pinterest_url'(newVal) {
      this.getSearch();
    },
    'filters.email'(newVal) {
      this.getSearch();
    },
  }
}
</script>